import { render, staticRenderFns } from "./InputIcon.vue?vue&type=template&id=428f482d&"
import script from "./InputIcon.vue?vue&type=script&lang=js&"
export * from "./InputIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCard,VIcon,VSelect})


/* hot reload */
if (module.hot) {
  var api = require("/builds/saas-tool/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('428f482d')) {
      api.createRecord('428f482d', component.options)
    } else {
      api.reload('428f482d', component.options)
    }
    module.hot.accept("./InputIcon.vue?vue&type=template&id=428f482d&", function () {
      api.rerender('428f482d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inputs/InputIcon.vue"
export default component.exports